var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuroStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6156 36.7973C61.5765 47.3996 54.4212 57.4158 43.6336 59.1689C32.8461 60.922 22.5115 53.7483 20.5506 43.1459C18.5896 32.5435 25.745 22.5274 36.5325 20.7743C47.32 19.0212 57.6547 26.1949 59.6156 36.7973Z",
    fill: "url(#paint0_linear_39132_3865)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0789 56.1693C52.1808 54.6901 58.2182 46.239 56.5636 37.2933C54.9091 28.3475 46.1893 22.2947 37.0873 23.7739C27.9853 25.2531 21.948 33.7042 23.6025 42.6499C25.257 51.5957 33.9769 57.6485 43.0789 56.1693ZM43.6336 59.1689C54.4212 57.4158 61.5765 47.3996 59.6156 36.7973C57.6547 26.1949 47.32 19.0212 36.5325 20.7743C25.745 22.5274 18.5896 32.5435 20.5506 43.1459C22.5115 53.7483 32.8461 60.922 43.6336 59.1689Z",
    fill: "url(#paint1_linear_39132_3865)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0481 38.717L32.767 38.4377C32.7866 37.3469 32.9412 36.3384 33.231 35.4122C33.5281 34.4757 33.9428 33.6515 34.4751 32.9397C35.0163 32.2263 35.6642 31.6407 36.4186 31.1828C37.182 30.7234 38.0382 30.4165 38.9872 30.2623C40.2495 30.0572 41.373 30.1238 42.3577 30.4623C43.3498 30.7905 44.2161 31.3113 44.9567 32.0248L43.8946 33.6112C43.8156 33.7328 43.7306 33.8463 43.6394 33.9518C43.5466 34.0484 43.4017 34.1128 43.2048 34.1448C43.0078 34.1768 42.8158 34.1355 42.6286 34.0209C42.4504 33.9048 42.2384 33.7807 41.9926 33.6484C41.7452 33.5074 41.4428 33.3934 41.0856 33.3064C40.7283 33.2195 40.2721 33.2211 39.7171 33.3113C38.7592 33.467 38.0047 33.9249 37.4537 34.6852C36.9116 35.4439 36.6207 36.4882 36.5807 37.8179L43.0667 36.7638L43.2693 37.8593C43.3084 38.0704 43.2518 38.2881 43.0996 38.5122C42.9548 38.7261 42.7256 38.8585 42.4123 38.9094L36.6917 39.8391C36.7072 39.9725 36.7279 40.1096 36.754 40.2504C36.7784 40.3824 36.8036 40.5188 36.8296 40.6595L36.9322 41.2139L42.3976 40.3257L42.6002 41.4211C42.6393 41.6323 42.5827 41.8499 42.4305 42.074C42.2856 42.2879 42.061 42.4196 41.7566 42.4691L37.4997 43.1609C38.0002 44.5206 38.6407 45.4905 39.4211 46.0706C40.2016 46.6507 41.0708 46.8629 42.0287 46.7072C42.4315 46.6417 42.7689 46.5461 43.0407 46.4204C43.3215 46.2932 43.5543 46.1557 43.739 46.0078C43.9327 45.8585 44.089 45.7062 44.2078 45.551C44.325 45.3869 44.4312 45.2382 44.5264 45.1049C44.6306 44.9702 44.7291 44.8545 44.8219 44.7578C44.9236 44.6597 45.0461 44.599 45.1893 44.5758C45.3057 44.5569 45.403 44.5592 45.4811 44.5827C45.5666 44.596 45.663 44.6438 45.7704 44.726L47.6455 45.8896C47.2068 46.9578 46.5422 47.8271 45.6519 48.4975C44.7615 49.1679 43.6762 49.6071 42.396 49.8151C41.3396 49.9868 40.3589 49.9694 39.4539 49.763C38.5563 49.5464 37.74 49.1715 37.0051 48.6384C36.2702 48.1053 35.6236 47.4264 35.0654 46.6017C34.5071 45.7771 34.0428 44.8374 33.6726 43.7828L32.0343 44.0491L31.6681 42.0693L33.1319 41.8315C33.105 41.7361 33.0834 41.6445 33.0672 41.5565C33.0509 41.4685 33.0338 41.3761 33.0159 41.2793C32.9899 41.1385 32.9647 41.0022 32.9402 40.8702C32.9248 40.7368 32.9085 40.5989 32.8914 40.4567L31.4143 40.6967L31.0481 38.717Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39132_3865",
    x1: 81,
    y1: 13,
    x2: 24.6671,
    y2: 86.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485095,
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485195,
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#D3D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39132_3865",
    x1: 81,
    y1: 13,
    x2: 24.6671,
    y2: 86.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485295,
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485352,
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#8E8CEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroStack);
export default __webpack_public_path__ + "static/media/euro-stack.b02373b5811ce7825558f8c0aa9281ce.svg";
export { ForwardRef as ReactComponent };